// extracted by mini-css-extract-plugin
module.exports = {"container":"Quiz_container__4o0lc","QuizCount":"Quiz_QuizCount__2aokT","text":"Quiz_text__26h54","QuizText":"Quiz_QuizText__30zcN"};